import api from "../utils/api";
import { LOGOUT } from "./types";

export const save = ({ uuid, personUuid, style, caption, shared }) => async (dispatch) => {
    try {
        const res = await api.post(`/calendars`, { uuid, person: personUuid, style, caption, shared });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
}

export const get = (uuid) => async (dispatch) => {
    try {
        const res = await api.get(`/calendars/i/${uuid}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
}

export const destroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.delete(`/calendars/i/${uuid}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
}

export const mine = () => async (dispatch) => {
    try {
        const res = await api.get(`/calendars/f/mine`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
}

export const firm = () => async (dispatch) => {
    try {
        const res = await api.get(`/calendars/f/firm`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
}

export const available = () => async (dispatch) => {
    try {
        const res = await api.get(`/calendars/f/shared`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
}

export const list = ({ owner, flags = "all" } = {}) => async (dispatch) => {
    try {
        const path = owner ? `/calendars/p/${owner}/f/${flags}` : `/calendars/f/${flags}`;
        const res = await api.get(path);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
}

export const search = ({ page = 0, size = 25, order = "caption", direction: _direction = "asc", search: _search = null }) => async (dispatch) => {
    try {
        const encodedSearch = encodeURIComponent((_search ?? "").toString().trim());
        const normalizedDirection = String(_direction).toLowerCase() === "desc" ? "desc" : "asc";
        const res = await api.get(`/calendars/p/${page}/s/${size}/o/${order}/${normalizedDirection}/${encodedSearch || ""}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
}
